import { makeStyles, tokens } from "@fluentui/react-components";

export const usePlaybookRuleEditorStyles = makeStyles({
  container: {
    marginTop: "1.5rem",
  },
  card: {
    gap: "1rem",
    padding: "1.5rem",
    marginTop: "1rem",
    backgroundColor: tokens.colorNeutralBackground2Selected,
  },
  addFallbackRuleButton: {
    alignSelf: "flex-start",
  },
});
